import React, { FunctionComponent, memo } from "react";
import { useIntl } from "react-intl";
import { isEqual } from "lodash";

import StatsTable from "components/stats-table";
import BaseCard, { cardLabel, BaseCardProps } from "./BaseCard";
import { SiteConfig_siteConfig_dashboardConf_components } from "graphql/generated";
import { getImageSrc } from "../../heating/HeatingTankUnitPreview"
import HeatingTankStatus from "../../heating/HeatingTankStatus"
import { useNavigate } from "react-router-dom";


interface IProps extends BaseCardProps {
  baseUrl: string;
  data: any;
  config: SiteConfig_siteConfig_dashboardConf_components;
}


const HeatingCard: FunctionComponent<IProps> = memo(function Heating({ data, config, baseUrl, ...rest }) {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <BaseCard {...rest}
      title={intl.formatMessage({
        id: "dashboard__heating____title",
        defaultMessage: `{count, plural,
          one {Heating}
          other {Heatings}
        } {label}`,
      }, {
        ...cardLabel(config),
      })}
      control={data?.heating_control}
      image={getImageSrc(data)}
      onClick={() => {
        navigate(`${baseUrl}/heating`);
      }}
    >
        <StatsTable
          inline
          rows={[
            {
                label: intl.formatMessage({
                id: "dashboard__heating__active_power",
                defaultMessage: "Thermal power",
                }),
                unit: "kW",
                decimals: 1,
                value: data?.active_power,
            },
            {
                label: intl.formatMessage({
                id: "dashboard__heating__temperature",
                defaultMessage: "Temperature",
                }),
                unit: "°C",
                decimals: 1,
                value: data?.temp,
            },
            {
                label: intl.formatMessage({
                id: "dashboard__heating__status",
                defaultMessage: "Status",
                }),
                value: <HeatingTankStatus state={data?.status} />,
            },
          ]}
        />
    </BaseCard>
  );
}, isEqual);

export default HeatingCard;
